var exports = {
  "Q": "content__bd_i2U",
};

module.exports = exports;
